import cx from 'classnames'
import Parser from 'html-react-parser'
import { MdHighlightOff, MdClose, MdRemove, MdAdd } from 'react-icons/md'

import { PlainButton } from '../../../shared/Button'
import { Divider } from '../../../shared/Divider'

import styles from './conflict.module.scss'

export function Conflict ({ withMargin, data, resolve }) {
  return (
    <div
      className={cx(styles.conflictWarning, {
        [styles.withMargin]: withMargin
      })}
    >
      <div>
        <div className={styles.block}>
          <MdHighlightOff size='1.5rem' />
        </div>
        <div className={styles.info}>
          <div className={styles.title}>Resolve Inconsistencies</div>
          <div className={styles.subTitle}>
            <p>
              Some grid records have been modified or removed. To apply the changes to the questionnaire, click the Resolve All button.
            </p>
          </div>
          <PlainButton
            label='RESOLVE ALL'
            btnType='contained'
            color='primary'
            onClick={resolve}
          />
        </div>
      </div>
      <Divider style={{ marginLeft: '40px' }} />
      <div className={styles.changes}>
        {data?.cancel?.length > 0 && (
          <>
            <p>The issue will be cancelled:</p>
            <div className={styles.cancelled}>
              {data.cancel.map((can, i) => (
                <p key={i}>
                  {Parser(can.description)}
                  <MdClose size='1rem' />
                </p>
              ))}
            </div>
          </>
        )}
        {data?.update?.length > 0 && (
          <>
            <p>The issue will be updated:</p>
            <div>
              {data.update.map((upd, i) => (
                <div
                  className={styles.updatedRow}
                  key={`upd-${i}`}
                >
                  <div className={styles.now}>
                    <MdAdd />
                    {Parser(upd.diff?.description?.current || upd.description)}
                  </div>
                  <div className={styles.old}>
                    <MdRemove />
                    {Parser(upd.diff?.description?.previous || upd.description)}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
